import React from 'react';
import PropTypes from 'prop-types';
import { Text, Pressable, View } from 'react-native';

import defaultStyles from './RadioButtonSelectBox.jss';

const RadioButtonSelectBox = ({ multipleSelection, heading, items, onSelect }) => {
    const newItems = [...items];

    const resetItems = () => {
        newItems.forEach((item) => {
            item.isSelected = false;
        });
    };

    const renderItems = () =>
        newItems.map((item, index) => {
            const { label, isSelected, testID, key } = item;
            return (
                <Pressable
                    key={key || `${label}_checkbox`}
                    testID={`${testID}_checkbox`}
                    style={[
                        defaultStyles.itemContainer,
                        index + 1 !== newItems.length ? defaultStyles.itemContainerWithBorder : {}
                    ]}
                    onPress={() => {
                        if (!multipleSelection) {
                            resetItems();
                        }
                        item.isSelected = !item.isSelected;
                        onSelect(item, index, newItems);
                    }}
                >
                    <View style={defaultStyles.itemLabelContainer}>
                        <View style={defaultStyles.radioButton}>
                            {isSelected && <View style={defaultStyles.radioButtonSelectedPoint} />}
                        </View>
                        <Text style={defaultStyles.itemLabel} numberOfLines={2}>
                            {label}
                        </Text>
                    </View>
                </Pressable>
            );
        });

    return (
        <View style={defaultStyles.container}>
            {heading && (
                <View style={defaultStyles.headingContainer}>
                    <Text style={defaultStyles.heading}>{heading}</Text>
                </View>
            )}
            <View style={defaultStyles.itemsContainer}>{renderItems()}</View>
        </View>
    );
};

RadioButtonSelectBox.defaultProps = {
    multipleSelection: false,
    heading: null
};

RadioButtonSelectBox.propTypes = {
    multipleSelection: PropTypes.bool,
    heading: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.string,
            isSelected: PropTypes.bool,
            testID: PropTypes.string
        })
    ).isRequired,
    onSelect: PropTypes.func.isRequired
};

export default RadioButtonSelectBox;
